import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import dotracking from "../../trackinglogs";
import trackobj from "../../trackingpages.json";
import {
  funderschoollist,
  studentfitnessmenuenable,
} from "../../../services/common";
import { funderprofile } from "../../../services/funder";

export const FunderSidebar = () => {
  const [subact, setSubAct] = useState(true);
  const [dashboard, setDashboard] = useState(true);

  const [touract, setTourAct] = useState(false);

  const [schact, setSchAct] = useState(false);
  const [stlistact, setSTListAct] = useState(false);

  const [peract, setPerAct] = useState(false);
  const [keyact, setKeyAct] = useState(false);
  const [achact, setAchAct] = useState(false);
  const [benact, setBenAct] = useState(false);
  const [classassessact, setClassAssessAct] = useState(false);

  const [fitact, setFitAct] = useState(false);
  const [fitlistact, setFitListAct] = useState(false);
  const [fittoplistact, setFitTopListAct] = useState(false);
  const [fitbotlistact, setFitBotListAct] = useState(false);
  const [schnatact, setSchNatAct] = useState(false);
  const [fittreact, setFitTreAct] = useState(false);
  const [schstateact, setSchStateAct] = useState(false);

  const [upact, setUpAct] = useState(false);
  const [upcmsact, setUPCmsAct] = useState(false);
  const [funcmsact, setFunCmsAct] = useState(false);

  const [schfmact, setSchFmAct] = useState(false);
  const [lschfmact, setLSchFmAct] = useState(false);

  function mainmenuactive(head) {
    setSubAct(false);
    setDashboard(false);

    setSchAct(false);
    setSTListAct(false);

    setTourAct(false);

    setUpAct(false);
    setUPCmsAct(false);
    setFunCmsAct(false);

    setPerAct(false);
    setKeyAct(false);
    setAchAct(false);
    setBenAct(false);
    setClassAssessAct(false);

    setFitAct(false);
    setFitListAct(false);
    setFitTopListAct(false);
    setFitBotListAct(false);
    setSchNatAct(false);
    setSchStateAct(false);
    setFitTreAct(false);

    setSchFmAct(false);
    setLSchFmAct(false);
    if (head === "Dashboard") {
      setSubAct(true);
      setDashboard(true);
      dotracking("dashboard menu $$ " + trackobj.dashheading);
      navigate("/funder/dashboard");
      if (window.innerWidth < 767) {
        const url = window.location.href;
        const head = url.split("/#/");
        const link = head[1].split("/");
        if (link[1] !== localStorage.getItem("Url")) {
          localStorage.setItem("Url", link[1]);
          window.location.reload();
        }
      }
    } else if (head === "Tournaments") {
      setTourAct(true);
      dotracking(
        "tournament list in tournament menu $$ " + trackobj.tourlistheading
      );
      navigate("/funder/tournamentlist");
      if (window.innerWidth < 767) {
        const url = window.location.href;
        const head = url.split("/#/");
        const link = head[1].split("/");
        if (link[1] !== localStorage.getItem("Url")) {
          localStorage.setItem("Url", link[1]);
          window.location.reload();
        }
      }
    } else if (head === "School") {
      setSchAct(true);
      dotracking("school list in school menu $$ " + trackobj.schoollistheading);
      navigate("/funder/schoollist");
      if (window.innerWidth < 767) {
        const url = window.location.href;
        const head = url.split("/#/");
        const link = head[1].split("/");
        if (link[1] !== localStorage.getItem("Url")) {
          localStorage.setItem("Url", link[1]);
          window.location.reload();
        }
      }
    } else if (head === "CMS") {
      setUpAct(true);
      // setUPCmsAct(true);
      // dotracking("cms menu $$ " + trackobj.addcmsheading);
      // navigate("/funder/addfundercms/" + localStorage.getItem("UID"));
    } else if (head === "Student") {
      setFitAct(true);
    } else if (head === "Performance") {
      setPerAct(true);
      if (window.innerWidth < 767) {
        const url = window.location.href;
        const head = url.split("/#/");
        const link = head[1].split("/");
        if (link[1] !== localStorage.getItem("Url")) {
          localStorage.setItem("Url", link[1]);
          window.location.reload();
        }
      }
    }else if (head === "Scholarships Forms") {
      setSchFmAct(true);
    }
  }
  const { id } = useParams();
  const { tid } = useParams();
  const { eid } = useParams();
  const { cid } = useParams();

  const navigate = useNavigate();
  function submenuactive(head, type) {
    setSubAct(false);
    setDashboard(false);

    setSchAct(false);
    setSTListAct(false);

    setTourAct(false);

    setUpAct(false);
    setUPCmsAct(false);
    setFunCmsAct(false);

    setPerAct(false);
    setKeyAct(false);
    setAchAct(false);
    setBenAct(false);
    setClassAssessAct(false);

    setFitAct(false);
    setFitListAct(false);
    setFitTopListAct(false);
    setFitBotListAct(false);
    setSchNatAct(false);
    setSchStateAct(false);
    setFitTreAct(false);

    setSchFmAct(false);
    setLSchFmAct(false);
    if (head === "dashboard") {
      setSubAct(true);
      setDashboard(true);
      navigate("/funder/dashboard");
    } else if (head === "contact") {
      setSubAct(true);
      setDashboard(true);
      navigate("/funder/contact");
    } else if (head === "changepassword") {
      setSubAct(true);
      setDashboard(true);
      navigate("/funder/changepassword");
    } else if (head === "schoollist") {
      setSchAct(true);
      setSTListAct(true);
      navigate("/funder/schoollist");
      // } else if (head === "allplayers") {
      //   setSchAct(true);
      //   setSTListAct(true);
      //   navigate("/funder/allplayers/" + id);
    } else if (head === "viewplayer") {
      setPerAct(true);
      setBenAct(true);
      navigate("/funder/viewplayer/" + id);
      // } else if (head === "addfundercms") {
      //   setUpAct(true);
      //   setUPCmsAct(true);
      //   navigate("/funder/addfundercms/" + id);
    } else if (head === "funderdetails") {
      setUpAct(true);
      setUPCmsAct(true);
      navigate("/funder/funderdetails");
    } else if (head === "tournamentlist") {
      setTourAct(true);
      navigate("/funder/tournamentlist");
    } else if (head === "tournamentdetails") {
      setTourAct(true);
      navigate("/funder/tournamentdetails/" + id);
    } else if (head === "photoupload") {
      setTourAct(true);
      navigate("/funder/photoupload/" + id);
    } else if (head === "externalphotoupload") {
      setTourAct(true);
      navigate("/funder/externalphotoupload/" + id);
    } else if (head === "externaltournamentdetails") {
      setTourAct(true);
      navigate("/funder/externaltournamentdetails/" + id);
    } else if (head === "categorylist") {
      setTourAct(true);
      navigate("/funder/categorylist/" + id);
    } else if (head === "poollist") {
      setTourAct(true);
      navigate("/funder/poollist/" + id + "/" + eid);
    } else if (head === "scheduleallocate") {
      setTourAct(true);
      navigate("/funder/scheduleallocate/" + id + "/" + eid);
    } else if (head === "schedulelist") {
      setTourAct(true);
      navigate("/funder/schedulelist/" + id + "/" + eid);
    } else if (head === "pointslist") {
      setTourAct(true);
      navigate("/funder/pointslist/" + id + "/" + eid);
    } else if (head === "results") {
      setTourAct(true);
      navigate("/funder/results/" + id);
    } else if (head === "athleticsresults") {
      setTourAct(true);
      navigate("/funder/athleticsresults/" + id);
    } else if (head === "assessmentdetail") {
      setPerAct(true);
      setBenAct(true);
      navigate("/funder/assessmentdetail/" + id + "/" + eid);
    } else if (head === "keyhighlights") {
      setPerAct(true);
      setKeyAct(true);
      if (type === true) {
        dotracking(
          "key highlights in sports performance menu $$ " +
          trackobj.keylistheading
        );
      }
      navigate("/funder/keyhighlights");
    } else if (head === "achievementlist") {
      setPerAct(true);
      setAchAct(true);
      if (type === true) {
        dotracking(
          "achievement list in sports performance menu $$ " +
          trackobj.achievelistheading
        );
      }
      navigate("/funder/achievementlist");
    } else if (head === "individualachievementlist") {
      setPerAct(true);
      setAchAct(true);
      navigate("/funder/individualachievementlist/" + id);
    } else if (head === "beneficiarylist") {
      setPerAct(true);
      setBenAct(true);
      if (type === true) {
        dotracking(
          "benificiary list in sports performance menu $$ " +
          trackobj.benelistheading
        );
      }
      navigate("/funder/beneficiarylist");
    } else if (head === "classsportsassessment") {
      setPerAct(true);
      setClassAssessAct(true);
      if (type === true) {
        dotracking(
          "class sports assessment in sports performance menu $$ " +
          trackobj.assessmentheading
        );
      }
      navigate("/funder/classsportsassessment");
    } else if (head === "othereventdetail") {
      setSubAct(true);
      setDashboard(true);
      navigate("/funder/othereventdetail/" + id);
    } else if (head === "fittestlist") {
      setFitListAct(true);
      setFitAct(true);
      if (type === true) {
        dotracking(
          "fittest list in student fitness menu $$ " + trackobj.fittestheading
        );
      }
      navigate("/funder/fittestlist");
    } else if (head === "fittesttoplist") {
      setFitTopListAct(true);
      setFitAct(true);
      if (type === true) {
        dotracking(
          "fittest top 10 list in student fitness menu $$ " +
          trackobj.fittesttopheading
        );
      }
      navigate("/funder/fittesttoplist");
    } else if (head === "fittestbottomlist") {
      setFitBotListAct(true);
      setFitAct(true);
      if (type === true) {
        dotracking(
          "fittest bottom 10 list in student fitness menu $$ " +
          trackobj.fittestbotheading
        );
      }
      navigate("/funder/fittestbottomlist");
    } else if (head === "fitnesstrends") {
      setFitTreAct(true);
      setFitAct(true);
      if (type === true) {
        dotracking(
          "fitness trends in student fitness menu $$ " +
          trackobj.fitnesstrendsheading
        );
      }
      navigate("/funder/fitnesstrends");
    } else if (head === "schoolvsnational") {
      setSchNatAct(true);
      setFitAct(true);
      if (type === true) {
        dotracking(
          "school vs national in student fitness menu $$ " +
          trackobj.schnatheading
        );
      }
      navigate("/funder/schoolvsnational");
    } else if (head === "schoolvsstate") {
      setSchStateAct(true);
      setFitAct(true);
      if (type === true) {
        dotracking(
          "school vs state in student fitness menu $$ " +
          trackobj.schstateheading
        );
      }
      navigate("/funder/schoolvsstate");
    } else if (head === "addfundercms") {
      setUpAct(true);
      setUPCmsAct(true);
      if (type === true) {
        dotracking("funder cms in cms menu $$ " + trackobj.addcmsheading);
      }
      navigate("/funder/addfundercms/" + localStorage.getItem("UID"));
    } else if (head === "funderreport") {
      setUpAct(true);
      setFunCmsAct(true);
      if (type === true) {
        dotracking("funder report in cms menu $$ " + trackobj.fundrepheading);
      }
      navigate("/funder/funderreport");
    } else if (head === "swimmingresults") {
      setTourAct(true);
      navigate("/funder/swimmingresults/" + id);
    }else if (head === "scholarshipformlist") {
      setSchFmAct(true);
      setLSchFmAct(true);
      navigate("/funder/scholarshipformlist");
      if (type === true) {
        dotracking(
          "list scholarship in scholarship form menu $$ " + trackobj.schlistheading
        );
      }
    }else if (head === "formregisterlist") {
      setSchFmAct(true);
      setLSchFmAct(true);
      navigate("/funder/formregisterlist/"+id);
    }else if (head === "viewschloarship") {
      setSchFmAct(true);
      setLSchFmAct(true);
      navigate("/funder/viewschloarship/"+id );
    }else if (head === "formregisterdetail") {
      setSchFmAct(true);
      setLSchFmAct(true);
      navigate("/funder/formregisterdetail/"+id +"/"+eid );
    }

    if (window.innerWidth < 767) {
      const url = window.location.href;
      const head = url.split("/#/");
      const link = head[1].split("/");
      if (link[1] !== localStorage.getItem("Url")) {
        localStorage.setItem("Url", link[1]);
        window.location.reload();
      }
    }
  }
  const [schcount, setSchCount] = useState("0");
  const [sfmenu, setSFMenu] = useState("");
  useEffect(() => {
    window.scrollTo(0, 0);
    const url = window.location.href;
    const head = url.split("/#/");
    const link = head[1].split("/");
    submenuactive(link[1], false);

    funderprofile().then((res3) => {
      if (res3.status === true) {
        funderschoollist(res3.data.funder_id).then((response) => {
          if (response.status === true) {
            setSchCount(response.data.school_list.length);
          }
        });

        studentfitnessmenuenable(res3.data.funder_id, 2).then((res) => {
          if (res.status === true) {
            setSFMenu(res.data);
          }
        });
      }
    });
  }, []);

  return (
    <Fragment>
      <div className="app-sidebar__overlay" data-toggle="sidebar"></div>
      <aside className="app-sidebar">
        <a className="header-brand left-meu-header-brand left-meu-header-style1 left-meu-header-brand-desktop">
          <img
            src={require("../../../assets/images/logo_sv.png")}
            className="header-brand-img desktop-logo"
            alt="Arox logo"
          />
          <img
            src={require("../../../assets/images/favicon.png")}
            className="header-brand-img mobile-view-logo"
            alt="Arox logo"
          />
        </a>
        <div className="navigationhead">
          <h4>Main Navigation</h4>
        </div>
        <div
          className="side-tab-body p-0 border-0 resp-vtabs hor_1"
          id="parentVerticalTab"
        >
          <div className="first-sidemenu">
            <ul className="resp-tabs-list hor_1">
              <li
                data-toggle="tooltip"
                data-placement="right"
                title="Vertical"
                className={
                  subact ? "active resp-tab-item hor_1" : "resp-tab-item hor_1"
                }
                onClick={() => mainmenuactive("Dashboard")}
              >
                <i className="side-menu__icon typcn typcn-device-desktop"></i>
                <div className="slider-text">Dashboard</div>
              </li>
              {schcount != 0 && (
                <li
                  data-toggle="tooltip"
                  data-placement="right"
                  title=""
                  data-original-title="School"
                  className={
                    schact
                      ? "active resp-tab-item hor_1"
                      : "resp-tab-item hor_1"
                  }
                  onClick={() => mainmenuactive("School")}
                  aria-controls="hor_1_tab_item-2"
                  role="tab"
                >
                  <i className="side-menu__icon mdi mdi-bank"></i>
                  <div className="slider-text">School</div>
                </li>
              )}

              <li
                data-toggle="tooltip"
                data-placement="right"
                title=""
                data-original-title="Tournament"
                className={
                  touract ? "active resp-tab-item hor_1" : "resp-tab-item hor_1"
                }
                onClick={() => mainmenuactive("Tournaments")}
                aria-controls="hor_1_tab_item-4"
                role="tab"
              >
                <i className="side-menu__icon pe-7s-ball"></i>
                <div className="slider-text">Tournaments</div>
              </li>
              {sfmenu == "" && (
                <li
                  data-toggle="tooltip"
                  data-placement="right"
                  title=""
                  data-original-title="Student"
                  className={
                    fitact
                      ? "active resp-tab-item hor_1"
                      : "resp-tab-item hor_1"
                  }
                  onClick={() => mainmenuactive("Student")}
                  aria-controls="hor_1_tab_item-2"
                  role="tab"
                >
                  <i className="side-menu__icon mdi mdi-account-multiple"></i>
                  <div className="slider-text">Student Fitness</div>
                </li>
              )}

              <li
                data-toggle="tooltip"
                data-placement="right"
                title=""
                data-original-title="Performance"
                className={
                  peract ? "active resp-tab-item hor_1" : "resp-tab-item hor_1"
                }
                onClick={() => mainmenuactive("Performance")}
                aria-controls="hor_1_tab_item-2"
                role="tab"
              >
                <i className="side-menu__icon fa fa-bar-chart"></i>
                <div className="slider-text">Sport Performance</div>
              </li>
              <li
                data-toggle="tooltip"
                data-placement="right"
                title=""
                data-original-title="CMS"
                className={
                  upact ? "active resp-tab-item hor_1" : "resp-tab-item hor_1"
                }
                onClick={() => mainmenuactive("CMS")}
                aria-controls="hor_1_tab_item-7"
                role="tab"
              >
                <i className="side-menu__icon typcn typcn-upload-outline"></i>
                <div className="slider-text">CMS</div>
              </li>
              <li
                data-toggle="tooltip"
                data-placement="right"
                title=""
                data-original-title="Scholarships Forms"
                className={
                  schfmact ? "active resp-tab-item hor_1" : "resp-tab-item hor_1"
                }
                onClick={() => mainmenuactive("Scholarships Forms")}
                aria-controls="hor_1_tab_item-7"
                role="tab"
              >
                <i className="side-menu__icon typcn typcn-mortar-board"></i>
                <div className="slider-text">Scholarships Forms</div>
              </li>
              {/* <li
                data-toggle="tooltip"
                data-placement="right"
                title=""
                data-original-title="Profile"
                className={
                  proact ? "active resp-tab-item hor_1" : "resp-tab-item hor_1"
                }
                onClick={() => mainmenuactive("Profile")}
                aria-controls="hor_1_tab_item-6"
                role="tab"
              >
                <i className="side-menu__icon mdi mdi-account-network"></i>
                <div className="slider-text">Profile</div>
              </li> */}
            </ul>
            <div className="second-sidemenu">
              <div className="resp-tabs-container hor_1">
                <h2
                  className="resp-accordion hor_1"
                  role="tab"
                  aria-controls="hor_1_tab_item-1"
                >
                  <span className="resp-arrow"></span>
                  <i className="side-menu__icon typcn typcn-device-desktop"></i>
                  <div className="slider-text">Dashboard</div>
                </h2>
                <div
                  className={
                    subact
                      ? "resp-tab-content hor_1 resp-tab-content-active"
                      : "resp-tab-content hor_1"
                  }
                  aria-labelledby="hor_1_tab_item-1"
                >
                  <div className="row">
                    <div className="col-md-12">
                      <h4 className="font-weight-normal">
                        <i className="side-menu__icon typcn typcn-device-desktop"></i>{" "}
                        Home
                      </h4>{" "}
                      <a
                        className={
                          dashboard ? "slide-item active" : "slide-item"
                        }
                      // onClick={() => submenuactive("dashboard",true)}
                      >
                        Dashboard
                      </a>
                    </div>
                  </div>
                </div>

                <h2
                  className="resp-accordion hor_1"
                  role="tab"
                  aria-controls="hor_1_tab_item-1"
                >
                  <span className="resp-arrow"></span>
                  <i className="side-menu__icon mdi mdi-bank"></i>
                  <div className="slider-text">School</div>
                </h2>
                <div
                  className={
                    schact
                      ? "resp-tab-content hor_1 resp-tab-content-active"
                      : "resp-tab-content hor_1"
                  }
                  aria-labelledby="hor_1_tab_item-1"
                >
                  <div className="row">
                    <div className="col-md-12">
                      <h4 className="font-weight-normal">
                        <i className="side-menu__icon mdi mdi-bank"></i> School
                      </h4>{" "}
                      <a
                        className={
                          stlistact ? "slide-item active" : "slide-item"
                        }
                        onClick={() => submenuactive("schoollist", true)}
                      >
                        School List
                      </a>
                    </div>
                  </div>
                </div>

                <h2
                  className="resp-accordion hor_1"
                  role="tab"
                  aria-controls="hor_1_tab_item-1"
                >
                  <span className="resp-arrow"></span>
                  <i className="side-menu__icon pe-7s-ball"></i>
                  <div className="slider-text">Tournaments</div>
                </h2>
                <div
                  className={
                    touract
                      ? "resp-tab-content hor_1 resp-tab-content-active"
                      : "resp-tab-content hor_1"
                  }
                  aria-labelledby="hor_1_tab_item-1"
                >
                  <div className="row">
                    <div className="col-md-12">
                      <h4 className="font-weight-normal">
                        <i className="side-menu__icon pe-7s-ball"></i>
                        Tournaments
                      </h4>{" "}
                      <a
                        className={touract ? "slide-item active" : "slide-item"}
                        onClick={() => submenuactive("tournamentlist", true)}
                      >
                        Tournament List
                      </a>
                    </div>
                  </div>
                </div>

                <h2
                  className="resp-accordion hor_1"
                  role="tab"
                  aria-controls="hor_1_tab_item-1"
                >
                  <span className="resp-arrow"></span>
                  <i className="side-menu__icon mdi mdi-account-multiple"></i>
                  <div className="slider-text">Student Fitness</div>
                </h2>
                <div
                  className={
                    fitact
                      ? "resp-tab-content hor_1 resp-tab-content-active"
                      : "resp-tab-content hor_1"
                  }
                  aria-labelledby="hor_1_tab_item-1"
                >
                  <div className="row">
                    <div className="col-md-12">
                      <h4 className="font-weight-normal">
                        <i className="side-menu__icon mdi mdi-account-multiple"></i>{" "}
                        Student Fitness
                      </h4>{" "}
                      <a
                        className={
                          fitlistact ? "slide-item active" : "slide-item"
                        }
                        onClick={() => submenuactive("fittestlist", true)}
                      >
                        Fittest List
                      </a>
                      <a
                        className={
                          fittoplistact ? "slide-item active" : "slide-item"
                        }
                        onClick={() => submenuactive("fittesttoplist", true)}
                      >
                        Top 10 List
                      </a>
                      <a
                        className={
                          fitbotlistact ? "slide-item active" : "slide-item"
                        }
                        onClick={() => submenuactive("fittestbottomlist", true)}
                      >
                        Bottom 10 List
                      </a>
                      <a
                        className={
                          schnatact ? "slide-item active" : "slide-item"
                        }
                        onClick={() => submenuactive("schoolvsnational", true)}
                      >
                        School Vs National
                      </a>
                      <a
                        className={
                          schstateact ? "slide-item active" : "slide-item"
                        }
                        onClick={() => submenuactive("schoolvsstate", true)}
                      >
                        School Vs State
                      </a>
                      <a
                        className={
                          fittreact ? "slide-item active" : "slide-item"
                        }
                        onClick={() => submenuactive("fitnesstrends", true)}
                      >
                        Fitness Trends
                      </a>
                      {/* <a
                        className={
                          newfittreact ? "slide-item active" : "slide-item"
                        }
                        onClick={() => submenuactive("genderfitnesstrends", true)}
                      >
                        Fitness Trends - Gender
                      </a> */}
                    </div>
                  </div>
                </div>

                <h2
                  className="resp-accordion hor_1"
                  role="tab"
                  aria-controls="hor_1_tab_item-1"
                >
                  <span className="resp-arrow"></span>
                  <i className="side-menu__icon fa fa-bar-chart"></i>
                  <div className="slider-text">Performance</div>
                </h2>
                <div
                  className={
                    peract
                      ? "resp-tab-content hor_1 resp-tab-content-active"
                      : "resp-tab-content hor_1"
                  }
                  aria-labelledby="hor_1_tab_item-1"
                >
                  <div className="row">
                    <div className="col-md-12">
                      <h4 className="font-weight-normal">
                        <i className="side-menu__icon fa fa-bar-chart"></i>{" "}
                        Performance
                      </h4>{" "}
                      <a
                        className={keyact ? "slide-item active" : "slide-item"}
                        onClick={() => submenuactive("keyhighlights", true)}
                      >
                        Key Highlights
                      </a>
                      <a
                        className={achact ? "slide-item active" : "slide-item"}
                        onClick={() => submenuactive("achievementlist", true)}
                      >
                        Achievements List
                      </a>
                      <a
                        className={benact ? "slide-item active" : "slide-item"}
                        onClick={() => submenuactive("beneficiarylist", true)}
                      >
                        Beneficiary List
                      </a>
                      <a
                        className={
                          classassessact ? "slide-item active" : "slide-item"
                        }
                        onClick={() => submenuactive("classsportsassessment", true)}
                      >
                        Class Sports Assessment
                      </a>
                    </div>
                  </div>
                </div>

                <h2
                  className="resp-accordion hor_1"
                  role="tab"
                  aria-controls="hor_1_tab_item-1"
                >
                  <span className="resp-arrow"></span>
                  <i className="side-menu__icon typcn typcn-upload-outline"></i>
                  <div className="slider-text">CMS</div>
                </h2>
                <div
                  className={
                    upact
                      ? "resp-tab-content hor_1 resp-tab-content-active"
                      : "resp-tab-content hor_1"
                  }
                  aria-labelledby="hor_1_tab_item-1"
                >
                  <div className="row">
                    <div className="col-md-12">
                      <h4 className="font-weight-normal">
                        <i className="side-menu__icon typcn typcn-upload-outline"></i>{" "}
                        CMS
                      </h4>{" "}
                      <a
                        className={
                          upcmsact ? "slide-item active" : "slide-item"
                        }
                        onClick={() => submenuactive("addfundercms", true)}
                      >
                        Funder CMS
                      </a>
                      <a
                        className={
                          funcmsact ? "slide-item active" : "slide-item"
                        }
                        onClick={() => submenuactive("funderreport", true)}
                      >
                        Funder Report
                      </a>
                    </div>
                  </div>
                </div>

                 <h2
                  className="resp-accordion hor_1"
                  role="tab"
                  aria-controls="hor_1_tab_item-1"
                >
                  <span className="resp-arrow"></span>
                  <i className="side-menu__icon typcn typcn-mortar-board"></i>
                  <div className="slider-text">Scholarships Forms</div>
                </h2>
                <div
                  className={
                    schfmact
                      ? "resp-tab-content hor_1 resp-tab-content-active"
                      : "resp-tab-content hor_1"
                  }
                  aria-labelledby="hor_1_tab_item-1"
                >
                  <div className="row">
                    <div className="col-md-12">
                      <h4 className="font-weight-normal">
                        <i className="side-menu__icon typcn typcn-mortar-board"></i>{" "}
                        Scholarships
                      </h4>{" "}
                      <a
                        className={lschfmact ? "slide-item active" : "slide-item"}
                        onClick={() => submenuactive("scholarshipformlist", true)}
                      >
                        Scholarships List
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- col-4 --> */}
      </aside>
    </Fragment>
  );
};
